module.exports = __webpack_public_path__ + "ai.0e3df55d54ef71f36834.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/ai.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/ai.svg
// module chunks = styles